import * as actionTypes from './actionTypes';

export const blockUi = () => ({
  type: actionTypes.BLOCK_UI
})

export const unBlockUi = () => ({
  type: actionTypes.UN_BLOCK_UI
})

export const incrementBlockCounter = () => ({
  type: actionTypes.INCREMENT_BLOCK_COUNTER
})

export const decrementBlockCounter = () => ({
  type: actionTypes.DECREMENT_BLOCK_COUNTER
})

export const cookie = (value) => ({
  type: actionTypes.SET_COOKIE,
  value
})

export const resetStore = lang => ({
  type: actionTypes.RESET_STORE,
  initState: {
    darkTitleBar: {
      currentCase: {
        status: "Unkown"
      }
    },
    cases: {},
    entities: {},
    countryInfo: [],
    currencyInfo: [],
    addresses: [],
    persons: [],
    currentCustomerDetails: {
      data: {
        primaryBusinessContacts: [],
        declarationSignatories: []
      },
      statuses: {
        basicDetails: {
          status: "incomplete"
        },
        addresses: {
          status: "incomplete"
        },
        primaryBusinessContacts: {
          status: "incomplete"
        },
        declarationSignatories: {
          status: "incomplete"
        }
      }
    },
    productDetails: {
      account: [],
      echannel: [],
      gls: [],
      achCredit: [],
      corporateCard: [],
      additionalData: []
    },
    currentProductAccount: {
      data: {
        accountSignatories: [],
        eChannelReporting: []
      },
      echannels: [],
      statuses: {
        basicDetails: {
          status: "incomplete"
        },
        addressAndContact: {
          status: "incomplete"
        },
        accountSignatories: {
          status: "incomplete"
        },
        paperStatement: {
          status: "incomplete"
        },
        eChannelReporting: {
          status: "incomplete"
        }
      }
    },
    currentProductEchannel: {
      data: {
        accountSignatories: [],
        eChannelReporting: []
      },
      echannels: [],
      statuses: {
        basicDetails: {
          status: "incomplete"
        },
        eChannelContacts: {
          status: "incomplete"
        },
        accessControlAndLimit: {
          status: "incomplete"
        },
        productEnablements: {
          status: "incomplete"
        }
      }
    },
    currentProductAch: {
      data: {
        formData: {
          otherAccounts: []
        }
      },
      statuses: {
        basicDetails: {
          status: "incomplete"
        },
        addressAndContacts: {
          status: "incomplete"
        },
        creditTransferReports: {
          status: "incomplete"
        },
        creditTransferSpecific: {
          status: "incomplete"
        },
        mandateServiceUserTraining: {
          status: "incomplete"
        },
        primaryAndAdditionalContact: {
          status: "incomplete"
        }
      }
    },
    currentProductCorporateCard: {
      data: {
        formData: {
        }
      },
      statuses: {
        specificDetails: {
          status: "incomplete"
        },
        addressAndContacts: {
          status: "incomplete"
        }
      }
    },
    caseBodyTabsState: {
      customerDetailsTab: {
        disabled: false,
        isComplete: false
      },
      productRequestsTab: {
        disabled: false,
        isComplete: false
      },
      documentationTab: {
        disabled: true,
        isComplete: false
      },
      activationTab: {
        disabled: true,
        isComplete: false
      },
      activeTabId: 0
    },
    activationTabDetails: [],
    lang
  }
})

export const setConfig = (value) => ({
  type: actionTypes.SET_CONFIG,
  value
})



// WEBPACK FOOTER //
// ./src/actions/actionCreator.js